import { render, staticRenderFns } from "./CheckoutBreakdown.vue?vue&type=template&id=8af7c686&"
import script from "./CheckoutBreakdown.vue?vue&type=script&lang=js&"
export * from "./CheckoutBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports